import Remarkable from 'remarkable'

const md = new Remarkable()

export default {
  configure: config => md.set(config),
  getHTML: markdown => md.render(markdown),
}
